import { NgModule } from '@angular/core';

import { GridTabNavigationComponent } from './grid-tab-navigation.component';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { TabNavigationModule } from 'libraries/component/tab-navigation/tab-navigation.module';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [
        CommonModule,
        BtnModule,
        TabNavigationModule,
    ],
    exports: [GridTabNavigationComponent],
    declarations: [GridTabNavigationComponent],
})
export class GridTabNavigationModule { }
